import { FieldList, FieldName, IRegistrationStepFactory, RegistrationStep, getRemainingSteps } from '../step';
import { StepName } from '../stepNames';
import { mapFieldToStep } from '../fieldsMap';
import { compareSteps } from '../stepPriority';
import { commonFactory } from './commonFactory';

export class SpecialistFactory implements IRegistrationStepFactory {
  createStep(name: StepName, fields: FieldList) {
    switch (name) {
      case StepName.Location:
        return this.createLocation(fields);
      case StepName.Acquaintance:
        return this.createAcquaintance(fields);
      case StepName.AfterAll:
        return this.createAfterAll();
      default:
        return commonFactory.createStep(name, fields);
    }
  }

  createLocation(fields: FieldList): RegistrationStep {
    return {
      name: StepName.Location,
      fields: [
        { name: 'cityId', required: fields.includes('cityId') },
        { name: 'address', required: fields.includes('address') },
        { name: 'location', required: fields.includes('location') },
        { name: 'deviceLocation', required: fields.includes('deviceLocation') },
      ],
    };
  }

  private createAcquaintance(fields: FieldList): RegistrationStep {
    return {
      name: StepName.Acquaintance,
      title: 'Как к Вам обращаться?',
      fields: [
        {
          name: 'name',
          label: 'Имя',
          placeholder: 'Ваше имя',
          required: fields.includes('name'),
        },
        {
          name: 'surname',
          label: 'Фамилия',
          placeholder: 'Ваша фамилия',
          required: fields.includes('surname'),
        },
        {
          name: 'birthDate',
          controlType: 'date',
          label: 'Дата рождения',
          placeholder: 'Дата рождения',
          required: fields.includes('birthDate'),
        },
      ],
    };
  }

  private createAfterAll(): RegistrationStep {
    return {
      name: StepName.AfterAll,
      fields: [],
    };
  }

  getStepNames(fields: Readonly<FieldName[]>): StepName[] {
    const steps = getRemainingSteps(fields, mapFieldToStep, compareSteps);
    const location = steps.indexOf(StepName.Location);
    if (location !== -1) {
      steps.splice(location, 0, StepName.Welcome);
    }
    steps.push(StepName.AfterAll);
    return steps;
  }
}
